import { render } from "./CSignatore.vue?vue&type=template&id=e80c4d20&ts=true"
import script from "./CSignatore.vue?vue&type=script&lang=ts"
export * from "./CSignatore.vue?vue&type=script&lang=ts"

import "./CSignatore.vue?vue&type=style&index=0&id=e80c4d20&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__